const marketingRoutes = [
  {
    path: "/pointDetail",
    name: "pointDetail",
    component: () => import("@/views/marketing/pointDetail.vue"),
    meta: {
      title: "积分明细",
      keepAlive: true,
    },
  },

  {
    path: "/activeUserList",
    name: "activeUserList",
    component: () => import("@/views/marketing/activeUserList.vue"),
    meta: {
      title: "激活用户",
      keepAlive: true,
    },
  },
  {
    path: "/activityNotice",
    name: "activityNotice",
    component: () => import("@/views/marketing/activityNotice.vue"),
    meta: {
      title: "活动通知",
      keepAlive: true,
    },
  },
];

export default marketingRoutes;
